import useWarehouseReceivingZone from "../customHooks/useWarehouseReceivingZone";
import { Select } from "antd";

const WarehouseReceivingZoneSelect = ({ warehouseId, ...rest }) => {
  const { data, isLoading } = useWarehouseReceivingZone(warehouseId);

  return (
    <Select disabled={isLoading} {...rest}>
      {data?.map(w => (
        <Select.Option key={w.id} value={w.id}>{w.name}</Select.Option>
      ))}
    </Select>
  );
};

export default WarehouseReceivingZoneSelect;